var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_vm._v(" Note, you are now under \""+_vm._s(_vm.profileName)+"\" account. "),_c('inline-svg',{staticClass:"svg-icon",attrs:{"src":_vm.iconLogoutUnderUser},on:{"click":_vm.logoutUnderOtherUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }